export class PRIVILEGES {
  public static EditLocalization = '56e72442-72ae-4705-96c2-0658236ceadd';
  public static TranslationKeysInUi = 'f5f41971-a11d-4d95-bde8-d047215e43bc';
  public static EditCommonData = 'c5d429c4-1107-4ce7-bfb7-13545585b107';
  public static EditManufacturing = 'cd97203d-95b0-4555-8292-87b56d2d2ecb';
  public static EditUser = '461aacd3-0a42-4ff2-849b-94a92b8a8021';
  public static ViewTeamData = '776c6753-29cb-4829-b092-504e6b22319b';
  public static ImeLogin = '7d1b71e3-167e-4184-bba5-4292d91390c6';
  public static SfcLogin = '411669f3-5359-42fd-ad3b-42203853f95d';
  public static MesLogin = '559aedf7-17a5-4e98-b6a6-0361156201bd';
  public static SystemAdministrator = '76d0febd-74a3-4f95-8f4a-f67c5b7dac60';

}

export class USERS
{
  public static Admin = 'defaced0-1111-2222-3333-4444deadbeef';
}
